import axios from 'axios';
import { config } from '../../config';

export class LoginService {
    static login(username, password, callback) {
        axios.post(`${config.punterApiUri}/login`, { username, password })
            .then((response) => {
                if (response.data.responseType === -1) callback(undefined, response.data.responseMessage);
                else callback(response.data.responseObject);
            })
            .catch((error) => {
                if (error.status === 500) callback(undefined, error.status);
                // console.error(error);
            });
    }

    static async getRegistrationOptions() {
        const titleListCategory = 3;
        const provinceListCategory = 13;
        const titleList = await axios.get(`${config.registrationListApiUri}/${titleListCategory}`);
        const provinceList = await axios.get(`${config.registrationListApiUri}/${provinceListCategory}`);
        const registrationOptions = {
            titles: titleList.data.responseObject,
            provinces: provinceList.data.responseObject
        };
        return registrationOptions;
    }

    static async registerUser(registrationForm) {
        return await axios.post(`${config.punterApiUri}`, registrationForm);
    }

    static async resetPassword(resetPasswordForm) {
        return await axios.put(`${config.resetPunterPasswordUri}`, {
            email: resetPasswordForm.email,
            cell: resetPasswordForm.cell,
            selectedResetMethod: resetPasswordForm.cell ? 'sms' : 'email',
            IdNumber: resetPasswordForm.IdNumber
        });
    }
}